/**
 * FONTE ÚNICA dos vídeos de creators (UGC) — home e PDP leem daqui.
 *
 * Arquivos hospedados no CDN da Shopify (não re-hospedar).
 * Todos verticais 9:16 (720x1280).
 *
 * `match`: pedaços de handle de produto onde o vídeo aparece na PDP.
 * Lista vazia = só aparece na home.
 *
 * O crédito à creator (@handle) é OBRIGATÓRIO em qualquer exibição.
 */

export interface CreatorVideo {
  id: string;          // slug
  creator: string;     // @handle da creator
  video: string;       // mp4 no CDN
  poster: string;      // capa jpg no CDN
  legenda: string;     // frase curta exibida no card
  match: string[];     // pedaços de handle de produto onde esse vídeo aparece
}

export const CREATOR_VIDEOS: CreatorVideo[] = [
  {
    id: 'kit-presente',
    creator: '@aguibergqvist',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-kit-presente-aguibergqvist.mp4?v=1788719959',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-kit-presente-aguibergqvist.jpg?v=1788719958',
    legenda: 'O kit que virou presente',
    match: ['kit-'],
  },
  {
    id: 'pele-sensivel',
    creator: '@aguibergqvist',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-pele-sensivel-aguibergqvist.mp4?v=1788719700',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-pele-sensivel-aguibergqvist.jpg?v=1788719699',
    legenda: 'Rotina para pele sensível',
    match: ['corporal'],
  },
  {
    id: 'maternidade',
    creator: '@chelsyeickoff',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-maternidade-chelsyeickoff.mp4?v=1788719894',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-maternidade-chelsyeickoff.jpg?v=1788719893',
    legenda: 'Cuidado na maternidade',
    match: [],
  },
  {
    id: 'maos-pes',
    creator: '@johssimao',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-maos-pes-johssimao.mp4?v=1788719529',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-maos-pes-johssimao.jpg?v=1788719529',
    legenda: 'Mãos e pés ressecados',
    match: ['maos', 'pes'],
  },
  {
    id: 'rotina',
    creator: '@eumilenecoutinho',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-rotina-eumilenecoutinho.mp4?v=1788719763',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-rotina-eumilenecoutinho.jpg?v=1788719762',
    legenda: 'Limpeza suave no dia a dia',
    match: ['sabonete'],
  },
  {
    id: 'ressecamento',
    creator: '@bru.ggoulart',
    video: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-ressecamento-bru-ggoulart.mp4?v=1788719830',
    poster: 'https://cdn.shopify.com/s/files/1/0696/8944/2491/files/nathof-ugc-ressecamento-bru-ggoulart.jpg?v=1788719830',
    legenda: 'Para áreas muito ressecadas',
    match: ['balsamo'],
  },
];

/** Vídeos que casam com o handle de um produto (para a PDP). */
export function getVideosForHandle(handle: string): CreatorVideo[] {
  if (!handle) return [];
  const h = handle.toLowerCase();
  return CREATOR_VIDEOS.filter((v) => v.match.some((m) => h.includes(m)));
}
